import { AppProviders } from 'providers';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { routes } from 'routers';
import { THEME_TYPE } from 'store/state';
import './App.scss';

function App() {
  const themeMode = localStorage.getItem('theme-mode');
  useEffect(() => {
    document.documentElement.style.setProperty(
      `--background`,
      themeMode === '1' ? '#fff' : '#000'
    );
  }, [themeMode]);

  return (
    <div className={`magellan ${THEME_TYPE[parseInt(themeMode ?? '1')]} `}>
      <AppProviders>
        <RouterProvider router={routes} />
      </AppProviders>
    </div>
  );
}

export default App;
